import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_REVENUE_DYNAMIC_CPM = createFcmDetails('revenue_dynamic_cpm', {
	owner: 'Monetization',
	context: 'promotion-service',
	description: 'Used as an experiment to give a better CPM ($ per impression) for better performing petitions',
	import: false,
	template: {
		multiplier_percent: 50,
		impressions_served_threshold: 1000,
		sign_conversion_percent_threshold: 5,
	},
});
